/**
 * Shapeway's Center Full layout for noty.
 */

module.exports = function ($) {

  $.noty.layouts.swBottomFull = {
    name: 'swBottomFull',
    options: {},
    container: {
      object: '<ul id="noty_swBottomFull_layout_container" />',
      selector: 'ul#noty_swBottomFull_layout_container',
      style: function () {
        $(this).css({
          bottom: '0',
          left: '0',
          position: 'fixed',
          width: '100vw',
          height: 'auto',
          margin: 0,
          padding: 0,
          listStyleType: 'none',
          zIndex: 10000000
        });
      }
    },
    parent: {
      object: '<li />',
      selector: 'li',
      css: {}
    },
    css: {
      display: 'none'
    },
    animation: {
      open: 'animated fadeIn', // Animate.css class names
      close: 'animated fadeOut' // Animate.css class names
    },
    addClass: ''
  };

};
